const Programs = () => {
  const programs = [
    {
      name: "Novartis",
      logo: "/images/novartis.png",
    },
    {
      name: "Pfizer",
      logo: "/images/pfizer.png",
    },
    {
      name: "Roche",
      logo: "/images/roche.png",
    },
    {
      name: "AstraZeneca",
      logo: "/images/astraZeneca.png",
    },
  ];
  return (
    <article className="my-8  md:items-center">
      <section className="my-8 md:w-2/3">
        <h3 className="p-12 text-[#6C757D] text-2xl font-semibold border-4 border-[#f67e93] rounded-[72px] text-center border-l-0 rounded-tl-none rounded-bl-none">
          This program made available through the support of
        </h3>
      </section>
      <section className="flex gap-8 justify-center md:justify-between my-12 w-full flex-wrap">
        {programs.map((program, index) => (
          <div key={index}>
            <img
              src={program.logo}
              width={300}
              height={300}
              className="object-contain"
              alt={program.name}
            />
          </div>
        ))}
      </section>
    </article>
  );
};

export default Programs;
